{
  "version": 1,
  "asset_id": "79c8904d-e718-42ab-a797-2e4b6f19f1ce",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/79c8904d-e718-42ab-a797-2e4b6f19f1ce/destination-roofing-crew-citrus-county-fl-768.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/79c8904d-e718-42ab-a797-2e4b6f19f1ce/destination-roofing-crew-citrus-county-fl-768.avif",
  "original_filename": "destination-roofing-crew-citrus-county-fl-768.avif",
  "size": 26668,
  "content_type": "image/avif",
  "created_at": "2026-07-21T15:42:33Z"
}
